import React from 'react';

import DatedDocumentsTable from './DatedDocumentsTable.jsx';
import DocumentEntity from '../../../../../../shared/src/entity/DocumentEntity';

export const groupDocumentsBySubCategory = documents =>
  documents.reduce((groups, doc) => {
    const group = groups.find(gr => gr.subCategory === doc.subCategoryName);
    if (group) {
      group.documents.push(doc);
      return groups;
    }
    groups.push({
      subCategory: doc.subCategoryName,
      documents: [doc],
    });
    return groups;
  }, []);

/**
 * Component that displays the different documents tables.
 *
 * There is one array per publication date.
 */
const DocumentsTable = ({ title, documents, emptyMessage }) => {
  if (!emptyMessage && documents.length === 0) {
    return null;
  }

  const documentGroups = groupDocumentsBySubCategory(documents);

  return (
    <div className="encart">
      {title && (
        <div className="intitule">
          <span>{title}</span>
        </div>
      )}
      <div>
        {documents.length === 0 ? (
          <div>{emptyMessage}</div>
        ) : (
          <div className="encart-table">
            {documentGroups.map(entry => (
              <DatedDocumentsTable
                key={entry.subCategoryName}
                subCategory={entry.subCategory}
                documents={entry.documents}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

DocumentsTable.propTypes = {
  /*
   * The list containing the documents to display.
   */
  documents: React.PropTypes.arrayOf(
    React.PropTypes.shape(DocumentEntity.shape),
  ).isRequired,
  /*
   * The table title
   */
  title: React.PropTypes.string,
  /*
   * The message to display when the list is empty (if undefined, the table is hidden instead)
   */
  emptyMessage: React.PropTypes.string,
};

export default DocumentsTable;



// WEBPACK FOOTER //
// ./book/src/commons/components/document/table/DocumentsTables.jsx